import { autoinject, bindable, bindingMode, customElement, observable } from 'aurelia-framework';
import { AuthService } from 'DataAccessLayer/Services/AuthService';
import { BaseCustomElement } from 'Common/BaseCustomElement';
import { DataService } from 'DataAccessLayer/Services/DataService';
import { GuidHelper } from 'Code/Helpers/GuidHelper';
import { I18N } from 'aurelia-i18n';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { ObserverLocator } from 'aurelia-binding';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { SystemService } from 'DataAccessLayer/Services/SystemService';
import { Router, activationStrategy } from 'aurelia-router';

@autoinject
export class DropDownListBaseCustomElement extends BaseCustomElement {

    @bindable({ defaultBindingMode: bindingMode.twoWay }) value: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) valuetext: string = null;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) valueIsNumber: boolean = true;
    @bindable({ defaultBindingMode: bindingMode.toView }) editable: boolean = true;
    @bindable({ defaultBindingMode: bindingMode.toView }) nullable: boolean = true;
    @bindable({ defaultBindingMode: bindingMode.toView }) multiple: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.toView }) entityName: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) columnName: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) enumType: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) onChange: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) parentValue: number = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) tabIndexId: number = -1;
    @bindable({ defaultBindingMode: bindingMode.toView }) fieldId: string = 'Id';
    @bindable({ defaultBindingMode: bindingMode.toView }) fieldCaption: string = 'Caption';
    @bindable({ defaultBindingMode: bindingMode.toView }) configJson: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) sourceEntityName: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) isStatic: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.toView }) staticValues: Array<any> = null;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) refresh: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.toView }) enumDescriptionsEnabled: Array<string> = null;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) otherText: string = null;

    protected id: string = StringHelper.Empty();
    protected element: any = null;
    protected customElement: any = null;
    protected selectOptionsArray: Array<any> = null;
    protected dataService: DataService = null;
    protected openSelect: boolean = false;
    protected selectedValues: any = null;
    protected i18n: I18N = null;
    protected router: Router = null;
    protected isCategories: boolean = false;
    protected isEntity: boolean = false;

    protected ddlType: string = "Classic";  // Classic / Choice
    protected caption: string = null;
    protected icon: string = null;
    protected iconColor: string = null;
    protected textColor: string = null;
    protected bckColor: string = null;

    protected index: number = -1;
    protected hideOpenedSelectCallback: any = null;
    protected suggestionsUL: any = null;
    protected scrollTop: number = 0;
    protected enumTypeId: number = null
    protected accessRightEnumerationType: any = null;

    protected _authService: AuthService = null;

    constructor(element: Element, dataService: DataService, i18n: I18N, router: Router, authService: AuthService) {
        super();

        this.element = element;
        this.dataService = dataService;
        this.id = GuidHelper.NewGuid();
        this.i18n = i18n;
        this.router = router;
        this.hideOpenedSelectCallback = this.CloseSelect.bind(this);
        this._authService = authService;
    }


    attached() {
        console.log(55555, typeof this.value, this.value);
        if (ObjectHelper.ObjectIs(this.configJson) && ObjectHelper.ObjectIs(this.configJson.FieldConfig)) {
            if (StringHelper.StringIs(this.configJson.FieldConfig.DdlType)) {
                this.ddlType = this.configJson.FieldConfig.DdlType;
                if (ObjectHelper.ObjectIs(this.value) && this.multiple == false) {
                    this.valuetext = this.value + '';
                }
                if (this.ddlType == "Choice" && ObjectHelper.IsNullOrUndefinedOrEmptyOrStringEmpty(this.value) && this.multiple == true) {
                    this.value = [];
                }                
            }
        }
    }

    async parentValueChanged(newValue, oldValue) {
        if (!ObjectHelper.IsNullOrUndefined(newValue) && newValue != oldValue) {
            await this.refreshSelectOptionsArray();
        }
    }
    async valuetextChanged(newValue, oldValue) {
        if (this.ddlType == "Choice" && StringHelper.StringIs(newValue)) {
            this.value = Number(newValue);
        }
    }

    async valueChanged(newValue, oldValue) {
        //console.log(88888883, this.columnName, newValue);
        if (this.multiple) {
            this.UpdateSelectedValues();
            this.UpdateSelect();
        }
        else {
            if (ObjectHelper.ObjectIs(this.valueIsNumber) && this.valueIsNumber === true && ObjectHelper.ObjectIs(newValue)) {
                this.value = newValue * 1;
            }
            this.UpdateCaption();
        }
        if (!ObjectHelper.Compare(newValue, oldValue, [], false).Same && this.onChange != null) {
            await this.onChange();
        }
    }


    protected iconRefresh: boolean = false;

    private UpdateCaption() {
        ($(this.element) as any).find(`#enumIcon${this.id} svg`).remove();
        this.iconRefresh = false;
        this.icon = null;
        this.iconColor = null;
        this.textColor = null;
        this.bckColor = null;
        if (ObjectHelper.IsNotNullAndUndefined(this.value) && ObjectHelper.IsNotNullAndUndefined(this.selectOptionsArray)) {
            let selectedItemById = this.selectOptionsArray.filter((item) => item[this.fieldId] == this.value)[0];
            if (ObjectHelper.IsNotNullAndUndefined(selectedItemById)) {
                this.caption = selectedItemById[this.fieldCaption];
                this.iconColor = selectedItemById['IconColor'];
                this.textColor = selectedItemById['TextColor'];
                this.bckColor = selectedItemById['BckColor'];
                this.icon = selectedItemById['Icon'];
                setTimeout(() => {
                    this.iconRefresh = StringHelper.StringIs(this.icon);
                }, 50);
            }
            else {
                this.caption = null;
            }
        }
        else {
            this.caption = null;
        }
    }

    private UpdateSelectedValues() {
        this.selectedValues = [];
        if (this.selectOptionsArray != null && this.selectOptionsArray.length > 0) {
            for (let index in this.value) {
                let selectedItemById = this.selectOptionsArray.filter((item) => item[this.fieldId] == this.value[index])[0];
                if (this.ObjectIs(selectedItemById)) {
                    let enumId = selectedItemById[this.fieldId];
                    let description = selectedItemById[this.fieldCaption];
                    this.selectedValues.push({
                        key: enumId,
                        value: description
                    });
                }
            }
        }
    }

    //async refreshChanged(newValue, oldValue) {
    //    if (await ObjectHelper.IsNotNullAndUndefined(this.refresh) && this.refresh == true && await ObjectHelper.IsNotNullAndUndefined(this.value) && await ObjectHelper.IsNotNullAndUndefined(this.caption)) {
    //        await this.SelectValue(this.value, this.caption);
    //        this.refresh = false;
    //    }
    //}

    async refreshSelectOptionsArray() {
        if (!this.isStatic) {
            if (this.isCategories) {
                let response = await this.dataService.GetCategoriesByProjectionName(this.entityName);

                if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('data')) {

                    this.selectOptionsArray = (JSON.parse(JSON.stringify(response['data'])));
                }
            }
            else if (this.isEntity && !StringHelper.IsNullOrEmpty(this.sourceEntityName)) {
                let response = await SystemService.Instance.GetEntityList(this.sourceEntityName);

                if (ObjectHelper.IsNotNullAndUndefined(response)) {
                    this.selectOptionsArray = (JSON.parse(JSON.stringify(response)));
                }
            }
            else if (!this.isCategories && !this.isEntity) {
                if (!StringHelper.IsNullOrEmpty(this.columnName)) {

                    let enumType = await SystemService.Instance.GetEnumType(this.entityName, this.columnName);

                    if (enumType == "EntityRoleType") {
                        enumType = "EntityRoleType_" + this.router.currentInstruction.params.entityName;
                    }
                    let response = await SystemService.Instance.GetEnumeration(enumType, this.parentValue, null);
                    if (ObjectHelper.ObjectIs(response) && this.ObjectIs(response['Items'])) {
                        let items: Array<any> = (JSON.parse(JSON.stringify(response['Items'])));
                        if (this.ArrayIs(this.enumDescriptionsEnabled) && this.ArrayIs(items)) {
                            let itemsEnabled: Array<any> = [];
                            for (let i1 = 0; i1 < items.length; i1++) {
                                if (this.enumDescriptionsEnabled.indexOf(items[i1].Description) >= 0) {
                                    itemsEnabled.push(items[i1]);
                                }
                            }
                            this.selectOptionsArray = itemsEnabled;
                        }
                        else {
                            this.selectOptionsArray = items;
                        }
                    }
                    if (ObjectHelper.ObjectIs(response) && ObjectHelper.ObjectIs(response['Id'])) {
                        this.enumTypeId = response['Id'];
                        this.enumType = enumType;
                    }
                }
                else if (StringHelper.StringIs(this.enumType)) {

                    let response = await SystemService.Instance.GetEnumeration(this.enumType, null, null);
                    if (this.ObjectIs(response) && this.ObjectIs(response['Items'])) {
                        let items: Array<any> = (JSON.parse(JSON.stringify(response['Items'])));
                        if (this.ArrayIs(this.enumDescriptionsEnabled) && this.ArrayIs(items)) {
                            let itemsEnabled: Array<any> = [];
                            for (let i1 = 0; i1 < items.length; i1++) {
                                if (this.enumDescriptionsEnabled.indexOf(items[i1].Description) >= 0) {
                                    itemsEnabled.push(items[i1]);
                                }
                            }
                            this.selectOptionsArray = itemsEnabled;
                        }
                        else {
                            this.selectOptionsArray = items;
                        }
                        this.enumTypeId = response['Id'];
                    }
                }

            }
        }
        else {
            this.selectOptionsArray = (JSON.parse(JSON.stringify(this.staticValues)));
        }

        // check if is not mutiple and if is nullabke
        if (!this.multiple && this.nullable && this.selectOptionsArray != null && this.selectOptionsArray.length > 0 && this.ddlType == "Classic") {
            // add new value as first
            let enumItem = {};
            if (this.valueIsNumber) {
                enumItem[this.fieldId] = -1;
            } else {
                enumItem[this.fieldId] = null;
            }
            enumItem['Description'] = this.i18n.tr('Undetermined');
            enumItem[this.fieldCaption] = this.i18n.tr('Undetermined');
            this.selectOptionsArray.unshift(enumItem);
        }
        //console.log(555555, this.selectOptionsArray)
    }

    async bind() {
        this.accessRightEnumerationType = await SystemService.Instance.GetAccessRightByEntity('EnumerationType');
        if (!StringHelper.IsNullOrEmpty(this.sourceEntityName)) {
            this.isEntity = true;
            if (this.sourceEntityName === 'Category') {
                this.isCategories = true;
            }
        }

        await this.refreshSelectOptionsArray();

        if (this.multiple) {
            this.UpdateSelectedValues();
            this.UpdateSelect();
        }
        else {
            this.UpdateCaption();
        }
    }

    public OpenSelect() {
        this.OpenOrCloseSelect();
    }

    OpenOrCloseSelect() {
        if (!this.openSelect) {
            document.body.addEventListener('click', this.hideOpenedSelectCallback, false);
            if (this.multiple) {
                let thisParent = this;
                ($(this.element) as any).find('div.multiple-preview').on('keydown', function (event) {
                    thisParent.keydown(event.keyCode);
                });
                ($(this.element) as any).find('div.multiple-preview').focus();
            }
            else {
                ($(this.element) as any).find('[role="caption"]').focus();
            }
            this.openSelect = true;
        } else if (this.openSelect) {
            ($(this.element) as any).find('div.multiple-preview').off('keydown');
            document.body.removeEventListener('click', this.hideOpenedSelectCallback);
            this.openSelect = false;
        }
    }

    public CloseSelect() {
        this.OpenOrCloseSelect();
    }

    public async SelectValue(enumId: any) {
        if (this.multiple) {
            if (await ObjectHelper.IsNullOrUndefined(this.value)) {
                this.value = new Array<number>();
            }

            if (this.IsSelected(enumId) && ObjectHelper.IsNotNullAndUndefined(this.value)) {
                this.value = this.value.filter(function (item) {
                    return item !== enumId;
                });
            }
            else {
                let temp = JSON.parse(JSON.stringify(this.value));
                temp.push(enumId);
                this.value = JSON.parse(JSON.stringify(temp));
            }
            this.OpenOrCloseSelect();
        }
        else {
            if (ObjectHelper.ObjectIs(enumId)) {
                if (this.valueIsNumber && enumId >= 0) {
                    let selectedItemById = this.selectOptionsArray.filter((item) => item[this.fieldId] == (enumId * 1))[0];
                    if (ObjectHelper.IsNotNullAndUndefined(selectedItemById)) {
                        this.caption = selectedItemById[this.fieldCaption];
                    }
                    this.value = (enumId * 1);
                }
                if (!this.valueIsNumber) {
                    let selectedItemById = this.selectOptionsArray.filter((item) => item[this.fieldId] == enumId)[0];
                    if (ObjectHelper.IsNotNullAndUndefined(selectedItemById)) {
                        this.caption = selectedItemById[this.fieldCaption];
                    }
                    this.value = enumId;
                }
            }
            else {
                this.caption = null;
                this.value = null;
            }

            if (this.openSelect) {
                this.OpenOrCloseSelect();
            }
        }
    }

    public SelectAll() {
        if (this.multiple && ObjectHelper.IsNotNullAndUndefined(this.selectOptionsArray)) {
            this.value = this.selectOptionsArray.filter((item) => item[this.fieldId] > 0).map(x => x[this.fieldId]);
        }
    }

    public RemoveValue(enumId: any) {
        if (this.multiple && ObjectHelper.ArrayIs(this.value)) {
            this.value = this.value.filter(function (item) {
                return item !== enumId;
            });
            if (!ObjectHelper.ArrayIs(this.value)) {
                this.value = null;
            }
        }
    }

    public async Reset() {
        this.value = null;
        this.caption = null;
        this.icon = null;
        this.iconColor = null;
        ($(this.element) as any).find(`#enumIcon${this.id} svg`).remove();
    }

    public IsSelected(enumId: any) {
        return this.multiple ?
            (ObjectHelper.IsNotNullAndUndefined(this.value) && this.value.length > 0 && this.value.indexOf(enumId) >= 0) :
            (ObjectHelper.IsNotNullAndUndefined(this.value) && this.value == enumId);
    }

    public UpdateSelect() {
        if (this.multiple) {
            let helpForNullSelectOptionsArray = JSON.parse(JSON.stringify(this.selectOptionsArray));
            this.selectOptionsArray = null;
            this.selectOptionsArray = JSON.parse(JSON.stringify(helpForNullSelectOptionsArray));
        }
    }

    keydown(key) {
        console.log(2220, key);
        //console.warn('keydown');
        // down
        if (key === 40) {
            if (!this.openSelect) {
                this.OpenOrCloseSelect();
            }
            if (this.index < this.selectOptionsArray.length - 1) {
                this.index++;
            } else {
                this.index = -1;
            }
            this.scroll();
            return;
        }

        // up
        if (key === 38) {
            if (this.index === -1) {
                this.index = this.selectOptionsArray.length - 1;
            } else if (this.index > 0) {
                this.index--;
            } else {
                this.index = -1;
            }
            this.scroll();
            return;
        }

        // escape
        if (key === 27) {
            if (this.openSelect) {
                this.OpenOrCloseSelect();
                this.collapse();
            }
            return;
        }

        // enter
        if (key === 13) {
            if (this.index >= 0) {
                this.SelectValue(this.selectOptionsArray[this.index][this.fieldId]);
                this.collapse();
            }
            return;
        }
        if ((key > 64 && key < 91) || (key > 96 && key < 123)) {
            if (ObjectHelper.ArrayIs(this.selectOptionsArray)) {
                let fromIndex: number = 0;
                if (this.index >= 0 && this.index < this.selectOptionsArray.length) {
                    fromIndex = this.index;
                }
                let nextIndex: number = this.FindNextIndexByChar(key, fromIndex);
                if (nextIndex >= 0) {
                    this.index = nextIndex;
                    this.scroll();
                } else {
                    nextIndex = this.FindNextIndexByChar(key, 0);
                    if (nextIndex >= 0) {
                        this.index = nextIndex;
                        this.scroll();
                    }
                }
            }
            return;
        }

        return true;
    }

    private FindNextIndexByChar(key, fromIndex): number {
        const charL: string = String.fromCharCode(key).toLowerCase();
        const charU: string = String.fromCharCode(key).toUpperCase();
        if (ObjectHelper.ArrayIs(this.selectOptionsArray) && fromIndex >= -1 && (fromIndex + 1) < this.selectOptionsArray.length) {
            for (let i1 = fromIndex + 1; i1 < this.selectOptionsArray.length; i1++) {
                if (this.selectOptionsArray[i1].Caption[0] === charL || this.selectOptionsArray[i1].Caption[0] === charU) {
                    return i1;
                }
            }
        }
        return -1;
    }

    scroll() {
        const ul = this.suggestionsUL;
        const li = ul.children.item(this.index === -1 ? 0 : this.index);
        this.scrollTop = li.offsetTop - (li.offsetHeight * 4);
    }

    collapse() {
        this.index = -1;
    }

    public SetupEnumeration() {
        if (this.enumTypeId > 0) {
            this.router.navigateToRoute('entityEdit', { entityName: 'EnumerationType', entityId: this.enumTypeId });
        }
    }
}